import { frontendURL } from 'dashboard/helper/URLHelper';
import TemplatesCentral from './TemplatesCentral.vue';
import DisparoCentral from './DisparoCentral.vue';
import HistoricoCentral from './HistoricoCentral.vue';

// Menu Meta (id 1 + e-mails MetaAccess — guard no backend): paginas centrais
// de Template / Disparo / Historico cruzando as caixas WhatsApp Cloud.
export const routes = [
  {
    path: frontendURL('accounts/:accountId/meta/templates'),
    name: 'meta_templates',
    component: TemplatesCentral,
    meta: {
      permissions: ['administrator'],
    },
  },
  {
    path: frontendURL('accounts/:accountId/meta/disparo'),
    name: 'meta_disparo',
    component: DisparoCentral,
    meta: {
      permissions: ['administrator'],
    },
  },
  {
    path: frontendURL('accounts/:accountId/meta/historico'),
    name: 'meta_historico',
    component: HistoricoCentral,
    meta: {
      permissions: ['administrator'],
    },
  },
];

export default { routes };
